import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Card from '../../../common/card/Card'
import Button from '../../../common/button/Button'
import { useGroupDashboardContext } from '../GroupDashboardContext'

const TeamSettingCard = () => {

  const params = useParams()
  const teamId = params.team_id
  const navigate = useNavigate()
  const { filtersData } = useGroupDashboardContext()
  
  const handleViewTeamSettings= () => {
    navigate(`/organization/${teamId}/team-settings`)
  }

  return (
    <Card className="msync-card--is-style-inline">
      <div className='msync-card__body'>
        <div className='msync-title msync-title--is-level-3'>{ `${filtersData.woo?.teams.singular_label} Settings` }</div>
        <p>{ filtersData.home?.panel_settings_description }</p>
      </div>
      <div class="msync-card__footer msync-flex msync-flex--density-8">
        <Button
          className="msync-button--is-style-outline"
          onClick={()=>handleViewTeamSettings()}
        >
          Manage { filtersData.woo?.teams.singular_label } Settings
        </Button>
      </div>
    </Card>
  )
}

export default TeamSettingCard
